import * as Actions from 'Actions/checkoutTransactionAction';
import {
    displayErrors,
    displaySmartyStreetWarnings,
    receiveAddressValidationStatus,
    receiveEmailValidationError,
    receiveCarbSubclassForm,
    removeWarningValidation
} from 'Actions/checkoutTransactionAction';
import { CANADA_ID, USA_ID } from 'Constants/Constants';
import * as ActionTypes from 'Types/CheckoutActionTypes';
import { sendGoogleAnalyticsEvent } from 'Actions/googleAnalyticsAction';
import { enterCheckout } from 'Actions/shoppingCartAction';

const genericErrorMessage = "Sorry, an error occurred. Please try again or contact Customer Service at 800.979.0122."

const CheckoutApiMiddlewareAction = (action, dispatch, getState) => {
    switch (action.type) {
        case ActionTypes.REQUEST_SUBMITCUSTOMERINFO:
            api.submitCustomerInfo(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_UPDATEADDRESSBOOK:
            api.updateAddressBook(action, dispatch, getState);
            break;
        case ActionTypes.UPDATE_BILLING_ADDRESS:
            api.updateBillingAddress(action, dispatch, getState);
            break;
        case ActionTypes.FINALIZE_CREDIT_CARD_PAYMENT:
            api.finalizeCreditCardPayment(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_ACKNOWLEDGE_CARB_TERMS:
            api.acknowledgeCarbTerms(action, dispatch, getState);
            break;
        case ActionTypes.UPDATE_PAYMENTMETHOD:
            api.updatePaymentMethod(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_SUBMIT_PAYPALEXPRESS:
            api.submitPaypalExpress(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_REMOVE_ITEMS:
            api.removeItems(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_REMOVE_CARB_NO_SALE_ITEMS:
            api.removeCarbItems(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_REMOVE_CARB_ACKNOWLEDGE_ITEMS:
            api.removeCarbItems(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_REMOVE_DROPSHIP_ITEMS:
            api.removeDropshipItems(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_REMOVE_TRUCK_FREIGHT_ITEMS:
            api.removeTruckFreightItems(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_CONFIRMATION_PAGE:
            api.getConfirmationPage(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_VALIDATED_SMARTY_STREET_ADDRESS:
            api.getValidatedStreetAddress(action, dispatch, getState);
            break;
        case ActionTypes.FETCH_PAYPAL_EXPRESS:
            api.fetchPayPalExpress(action, dispatch, getState);
            break;
        case ActionTypes.FETCH_PAYPAL_EXPRESS_AUTHORIZE:
            api.fetchPayPalExpressAuthorize(action, dispatch, getState);
            break;
        case ActionTypes.SUBMIT_EMAIL_SIGN_UP:
            api.submitEmailSignUp(action, dispatch, getState)
            break;
        case ActionTypes.SUBMIT_LOYALTY_SIGN_UP:
            api.submitLoyaltySignUp(action, dispatch, getState)
            break;
        case ActionTypes.UPDATE_CARB_SUBCLASS_FORM:
            api.updateCarbSubclassForm(action, dispatch, getState);
            break;
        default:
            break;
    }
}

// API wrapper to avoid naming collision
var api = {};

var api = {
    submitCustomerInfo: (action, dispatch, getState) => {
        const { guestCheckoutAddressForm, addressHasBeenValidated, smartyIsCommercial } = getState().transaction
        let countryId = guestCheckoutAddressForm.countryId
        let provinceId
        let province
        if (countryId === USA_ID || countryId === CANADA_ID) {
            provinceId = guestCheckoutAddressForm.provinceId
        } else {
            province = guestCheckoutAddressForm.province
        }

        let transactionIdFromLocalStorage = window.localStorage.getItem("TransactionId")
        let data = {
            PremadeTransactionId: transactionIdFromLocalStorage,
            ShipToAddress: {
                Email: guestCheckoutAddressForm.email,
                PhoneNumber: guestCheckoutAddressForm.phoneNumber,
                FullName: guestCheckoutAddressForm.fullName,
                AddressLine1: guestCheckoutAddressForm.addressLine1,
                AddressLine2: guestCheckoutAddressForm.addressLine2,
                Company: guestCheckoutAddressForm.company,
                City: guestCheckoutAddressForm.city,
                ProvinceId: provinceId,
                Province: province,
                CountryId: countryId,
                PostalCode: guestCheckoutAddressForm.postalCode,
                SignUpforEmails: guestCheckoutAddressForm.isEmailListCheckboxActive,
                SignUpForSms: guestCheckoutAddressForm.isTextListCheckboxActive,
                SignUpForTransactionalSms: guestCheckoutAddressForm.isTransactionalTextListCheckboxActive,
                SignupForPromotionalSms: guestCheckoutAddressForm.isPromotionalTextListCheckboxActive,
                AddressName: guestCheckoutAddressForm.addressLine1, // this is default behavior during checkout. we need an address name to be valid in the address book
                AddressHasBeenValidated: addressHasBeenValidated,
                SmartyIsCommercial: smartyIsCommercial
            }
        }

        let url = '/data/buy/submitcheckoutinformation'
        return fetch(url,
            {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                let smartyStreetErrors = json.checkoutTransactionRm.addressValidationErrors

                if (json.checkoutTransactionRm.isEmailInvalid) {
                    dispatch(receiveEmailValidationError())
                    dispatch(Actions.disableLoader())
                    dispatch(displayErrors({ ADDRESS_FORM_EMAIL: ["Please enter a valid email"] }))
                    document.getElementById('guestCheckoutContainer').scrollIntoView();
                } else if (json.status.success && smartyStreetErrors && smartyStreetErrors.hasSmartyStreetErrors) {
                    dispatch(receiveAddressValidationStatus(json.checkoutTransactionRm.addressValidationErrors))
                    dispatch(displaySmartyStreetWarnings(smartyStreetErrors))
                    dispatch(Actions.disableLoader())
                } else {
                    if (json.status.success === false) {
                        Actions.handleErrors(json.status, true, dispatch);
                    }
                    if (json.checkoutTransactionRm) {
                        dispatch(Actions.receiveSubmitCustomerInfo(json));
                    }
                    if (json.status.success) {
                        action.history.push(`/buy/shipping?transactionId=` + json.checkoutTransactionRm.transactionId);
                    } else {
                        if (json.status.errorMessage) {
                            dispatch(Actions.disableLoader())
                            alert(json.status.errorMessage)
                            console.error('alert modal displayed submitCustomerInfo', json.status.errorMessage)
                        } else {
                            dispatch(Actions.disableLoader())
                            alert(genericErrorMessage)
                            console.error('alert modal displayed submitCustomerInfo')
                        }
                    }
                }
            })
            .catch(error => {
                console.error('Unable to enter checkout', data, url, error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    updateAddressBook: (action, dispatch, getState) => {
        const { transactionId, addressBookAddressForm, addressHasBeenValidated, paymentMethodContainer } = getState().transaction

        dispatch(removeWarningValidation())

        const data = {
            transactionAddress: {
                transactionId: transactionId,
                IsShipping: action.payload.isShipping,
                IsBilling: action.payload.isBilling,
                addressHasBeenValidated: addressHasBeenValidated,
                transactionAddress: {
                    addressId: addressBookAddressForm.addressId,
                    addressLine1: addressBookAddressForm.addressLine1,
                    addressLine2: addressBookAddressForm.addressLine2,
                    city: addressBookAddressForm.city,
                    province: addressBookAddressForm.province,
                    provinceId: addressBookAddressForm.provinceId,
                    countryId: addressBookAddressForm.countryId,
                    postalCode: addressBookAddressForm.postalCode,
                    fullName: addressBookAddressForm.fullName,
                    phoneNumber: addressBookAddressForm.phoneNumber,
                    email: addressBookAddressForm.email,
                    addressName: addressBookAddressForm.addressLine1, // this is default behavior during checkout. we need an address name to be valid in the address book
                    company: addressBookAddressForm.company
                },
                isBraintreePaypalAddress: paymentMethodContainer?.paymentMethod == 'PayPal',
                isMobilePayAddress: paymentMethodContainer?.paymentMethod == 'GooglePay' || paymentMethodContainer?.paymentMethod == 'ApplePay'
            }
        };
        return fetch("/data/buy/updatetransactionaddress",
            {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    Actions.handleErrors(json.status, true, dispatch)
                }
                if (json.checkoutTransactionRm.isEmailInvalid) {
                    dispatch(Actions.disableLoader())
                    dispatch(displayErrors({ ADDRESS_FORM_EMAIL: ["Please enter a valid email"] }))
                    document.getElementById('addressBookContainer').scrollIntoView();
                } else if (json.checkoutTransactionRm) {
                    dispatch(Actions.receiveAddAddressToAddressBook(json));
                }
            })
            .catch(error => {
                console.error('updateShippingAddress Error:', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    updateBillingAddress: (action, dispatch, getState) => {
        const { transactionId, billingAddressForm, addressLookup, addresses } = getState().transaction;
        const selectedShippingAddress = addresses[addressLookup.shippingAddressId];

        let data = {
            transactionAddress: {
                transactionId: transactionId,
                isBilling: true,
                isShipping: false,
                transactionAddress: {
                    addressId: billingAddressForm.addressId,
                    addressLine1: billingAddressForm.addressLine1,
                    addressLine2: billingAddressForm.addressLine2,
                    city: billingAddressForm.city,
                    province: billingAddressForm.province,
                    provinceId: billingAddressForm.provinceId,
                    countryId: billingAddressForm.countryId,
                    postalCode: billingAddressForm.postalCode,
                    fullName: billingAddressForm.fullName,
                    phoneNumber: selectedShippingAddress.phoneNumber,
                    email: selectedShippingAddress.email
                }
            }
        };

        return fetch("/data/buy/updatetransactionaddress",
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    console.error('updateBillingAddress Error:', json.status.errorMessage)
                    dispatch(Actions.disableLoader());
                    alert(json.status.errorMessage);
                }
                if (json.checkoutTransactionRm) {
                    if (!json.status.success) {
                        console.error('Status was unsuccessful for updatetransactionaddress but finalizeCreditCardPayment was dispatched anyway.')
                    }
                    dispatch(Actions.finalizeCreditCardPayment());
                }
            })
            .catch(error => {
                console.error('updateBillingAddress Error:', error)
                dispatch(Actions.disableLoader());
                alert(genericErrorMessage)
            })
    },
    finalizeCreditCardPayment: (action, dispatch, getState) => {
        const transactionId = getState().transaction.transactionId;

        let data = {
            transactionId: transactionId
        };

        return fetch("/data/buy/finalizecreditcardpayment",
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success && json.status.redirectUrl) {
                    window.location.href = json.status.redirectUrl;
                } else {
                    if (json.status.errorMessage) {
                        console.error('finalizecreditcardpayment Error:', json.status.errorMessage);
                    } else {
                        console.error('finalizecreditcardpayment Error:', 'No error was provided');
                    }

                    dispatch(Actions.updatePaymentTechIframe());
                    alert(genericErrorMessage);
                }
            })
            .catch(error => {
                console.error('finalizecreditcardpayment Error:', error);
                dispatch(Actions.updatePaymentTechIframe());
                alert(genericErrorMessage)
            })
    },
    acknowledgeCarbTerms: (action, dispatch, getState) => {
        const transactionId = getState().transaction.transactionId;

        let data = {
            transactionId: transactionId,
            carbSubClasses: action.payload.carbSubClasses,
            nameCarbDealerNoContractTerms: action.payload.nameCarbDealerNoContractTerms
        };

        if (data.carbSubClasses) {
            data.carbVehicleAMs = [{
                year: action.payload.year,
                make: action.payload.make,
                model: action.payload.model,
                raceType: action.payload.raceType,
                raceLocation: action.payload.raceLocation,
                isRaceCar: action.payload.isRaceCar
            }]
        }

        return fetch("/data/buy/acknowledgeCarbTerms",
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success) {
                    dispatch(Actions.receiveAcknowledgeCarbTerms(json))
                } else {
                    if (json.status.errorMessage) {
                        console.error('acknowledgeCarbTerms Error:', json.status.errorMessage);
                    } else {
                        console.error('acknowledgeCarbTerms Error:', 'No error was provided');
                    }

                    dispatch(Actions.disableLoader());
                    alert(genericErrorMessage);
                }
            })
            .catch(error => {
                console.error('acknowledgeCarbTerms Error:', error)
                dispatch(Actions.disableLoader());
                alert(genericErrorMessage)
            })
    },
    removeItems: (action, dispatch, getState) => {
        const transaction = getState().transaction

        let data = {
            TransactionId: transaction.transactionId,
            LineItems: action.payload.items,
            IsPayPalExpress: action.payload.isPayPalExpress
        }
        return fetch("/data/buy/removeitemsfromtransaction",
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success === false) {
                    Actions.handleErrors(json.status, true, dispatch);
                }
                else if (json.status.success) {
                    dispatch(Actions.receiveRemoveItems(json))
                }
                else {
                    if (json.status.errorMessage) {
                        console.error('requestRemoveItems Error:', json.status.errorMessage);
                    } else {
                        console.error('requestRemoveItems Error:', 'No error was provided');
                    }
                }
            })
            .catch(error => {
                console.error('requestRemoveItems Error:', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    removeDropshipItems: (action, dispatch, getState) => {

        const transaction = getState().transaction

        let data = {
            TransactionId: transaction.transactionId,
            LineItems: action.payload.dropshipItems,
            IsPayPalExpress: action.payload.isPayPalExpress
        }
        return fetch("/data/buy/removedropshipitemsfromtransaction",
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success === false) {
                    Actions.handleErrors(json.status, true, dispatch);
                }
                else if (json.status.success) {
                    dispatch(Actions.receiveRemoveDropshipItems(json))
                }
                else {
                    if (json.status.errorMessage) {
                        console.error('removedropshipitemsfromtransaction Error:', json.status.errorMessage);
                    } else {
                        console.error('removedropshipitemsfromtransaction Error:', 'No error was provided');
                    }
                }
            })
            .catch(error => {
                console.error('removeDropshipItems Error:', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    removeTruckFreightItems: (action, dispatch, getState) => {

        const transaction = getState().transaction

        let data = {
            TransactionId: transaction.transactionId,
            LineItems: action.payload.truckFreightItems,
            IsPayPalExpress: action.payload.isPayPalExpress
        }
        return fetch("/data/buy/removetruckfreightitemsfromtransaction",
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success === false) {
                    Actions.handleErrors(json.status, true, dispatch);
                }
                else if (json.status.success) {
                    dispatch(Actions.receiveRemoveTruckFreightItems(json))
                }
                else {
                    if (json.status.errorMessage) {
                        console.error('removetruckfreightitemsfromtransaction Error:', json.status.errorMessage);
                    } else {
                        console.error('removetruckfreightitemsfromtransaction Error:', 'No error was provided');
                    }
                }
            })
            .catch(error => {
                console.error('removeTruckFreightItems Error:', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    removeCarbItems: (action, dispatch, getState) => {
        const transaction = getState().transaction
        dispatch({
            type: ActionTypes.CARB_ITEMS_REMOVED,
            transactionId: transaction.transactionId,
            items: action.payload.items,
        })

        let data = {
            TransactionId: transaction.transactionId,
            LineItems: action.payload.items,
            IsPayPalExpress: action.payload.isPayPalExpress
        }
        return fetch("/data/buy/removecarbitemsfromtransaction",
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success === false) {
                    Actions.handleErrors(json.status, true, dispatch)
                }
                if (json.checkoutTransactionRm) {
                    dispatch(Actions.receiveRemoveCarbItems(json));
                }
            })
            .catch(error => {
                console.error('removeCarbItems Error:', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    updatePaymentMethod: (action, dispatch, getState) => {

        const transaction = getState().transaction

        if (!transaction.paymentMethodContainer.isBrainTreeEnabled) {
            UpdatePaymentForPaymentTech(transaction, dispatch, action)
        }
    },
    submitPaypalExpress: (action, dispatch, getState) => {

        dispatch(Actions.enableLoader())

        const state = getState();

        const transactionId = state.transaction.transactionId
        const paypalTransactionId = state.transaction.paypalTransactionId
        const phoneNumber = state.transaction.payPalExpressForm.phoneNumber
        const deliveryInstructions = state.transaction.shippingMethodContainer.deliveryInstructions


        let data = {
            transactionId: transactionId,
            paypalTransactionId: paypalTransactionId,
            phoneNumber: phoneNumber,
            CommentDeliveryInstructions: deliveryInstructions
        }

        return fetch("/data/buy/finalizepaypalexpress",
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (json.status.success && json.status.redirectUrl) {
                    window.location.href = json.status.redirectUrl;
                } else {
                    Actions.handleErrors(json.status, true, dispatch)
                }
            })
            .catch(error => {
                console.error('finalizePayPalExpress Error:', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    getConfirmationPage: (action, dispatch, getState) => {

        dispatch(Actions.enableLoader())

        let data = {
            transactionId: action.payload
        }

        return fetch("/data/buy/confirmation",
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    Actions.handleErrors(json.status, true, dispatch)
                }
                if (json.checkoutTransactionRm) {
                    dispatch(Actions.receiveConfirmationPage(json))
                    dispatch(Actions.hydratedConfirmationPage(json))
                }
            })
            .catch(error => {
                console.error('fetchConfirmationPage', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },

    submitEmailSignUp: (action, dispatch, getState) => {
        dispatch(Actions.enableLoader())

        let signUpState = getState().transaction.emailSignUp;
        console.log(getState())
        let data = {
            emailAddress: signUpState.emailAddress,
            phoneNumber: signUpState.phoneNumber,
            source: signUpState.emailSignupSource,
            signupPhoneTransactional: signUpState.smsTransactionalOptIn,
            signupPhonePromotional: signUpState.smsPromotionalOptIn,
            emailSignUpStatusType: signUpState.emailSignUpStatusType
        }

        return fetch("/MailingList/SignupEmailOrSms",
            {
                method: "Post",
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                dispatch(Actions.receiveEmailSignUpResponse(json))
            }).catch(error => {
                console.error('submitEmailSignUp', error)
                dispatch(Actions.disableLoader())
            })
    },
    submitLoyaltySignUp: (action, dispatch, getState) => {
        dispatch(Actions.enableLoader())

        let signUpState = getState().transaction.loyaltySignUp;
        console.log(getState())

        let gaClientId
        try {
            gaClientId = ga4SessionData.clientId
        } catch (e) {
            gaClientId = ''
        }

        let data = {
            loyaltyEmail: signUpState.loyaltyEmail,
            fullName: signUpState.fullName,
            webUserGuid: signUpState.webUserGuid,
            gaClientId: gaClientId
        }

        return fetch("/Account/SignupLoyaltyAccount",
            {
                method: "Post",
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                dispatch(Actions.receiveLoyaltySignUpResponse(json))
            }).catch(error => {
                console.error('submitLoyaltySignUp', error)
                dispatch(Actions.disableLoader())
            })
    },
    getValidatedStreetAddress: (action, dispatch, getState) => {
        let addressForm = getState().transaction.addressForm

        let address = {
            ...action.payload.formAddress,
            addressLine1: action.payload.address.street,
            city: action.payload.address.city,
            province: action.payload.address.state,
            provinceId: null
        }

        let data = {
            address: address,
            isBillingAddress: action.payload.updateFormAction === ActionTypes.UPDATE_BILLING_ADDRESS_FORM
        }

        return fetch("/data/buy/validateautocompleteaddress",
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                let actionAddressForm = {}

                if (json && json.addressLine1) {
                    addressForm.smartyStreetAddress = json

                    dispatch(Actions.receiveValidatedSmartyStreetAddress(addressForm))

                    actionAddressForm = {
                        addressLine1: json.addressLine1 || "",
                        addressLine2: json.addressLine2 || "",
                        city: json.city || "",
                        countryId: json.countryId || USA_ID,
                        postalCode: json.postalCode || "",
                        province: json.province || "",
                        provinceId: json.provinceId || "",
                        phone: json.phone || "",
                        fullName: json.fullName || "",
                        email: json.email || "",
                        company: json.company || ""
                    }

                    if (json?.smartyStreetErrors?.hasSmartyStreetErrors) {
                        dispatch(displaySmartyStreetWarnings(json.smartyStreetErrors))
                        dispatch(receiveAddressValidationStatus(json.smartyStreetErrors))
                    }
                }
                else {
                    dispatch(Actions.disableLoader())

                    actionAddressForm = {
                        addressLine1: action.payload.address.street,
                        addressLine2: "",
                        city: action.payload.address.city,
                        countryId: USA_ID,
                        postalCode: "",
                        province: "",
                        provinceId: "",
                        smartyStreetErrors: ""
                    }
                }

                switch (action.payload.updateFormAction) {
                    case ActionTypes.UPDATE_CUSTOMER_INFO_ADDRESS_FORM:
                        dispatch(Actions.updateCustomerInfoAddressForm(actionAddressForm))
                        break;
                    case ActionTypes.UPDATE_ADDRESS_BOOK_ADDRESS_FORM:
                        dispatch(Actions.updateAddressBookAddressForm(actionAddressForm))
                        break;
                    case ActionTypes.UPDATE_BILLING_ADDRESS_FORM:
                        dispatch(Actions.updateBillingAddressForm(actionAddressForm))
                        break;
                    case ActionTypes.UPDATE_PAYPAL_ADDRESS_FORM:
                        dispatch(Actions.updatePaypalAddressForm(actionAddressForm))
                        break;
                    case ActionTypes.UPDATE_MOBILEPAY_ADDRESS_FORM:
                        dispatch(Actions.updateMobilePayAddressForm(actionAddressForm))
                        break;
                    default:
                        break;
                }
            })
            .catch(error => {
                console.error('getValidatedStreetAddress', error)
            })
    },
    fetchPayPalExpress: (action, dispatch, getState) => {

        const pathname = (window.location.pathname).toLowerCase();
        if (pathname.startsWith('/shoppingcart') && !navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
            dispatch(sendGoogleAnalyticsEvent('Cart', 'Clicked PayPal Smart Button', 'Order Details'))
        }
        if (pathname.startsWith('/buy/customerinfo') && !navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
            dispatch(sendGoogleAnalyticsEvent('Checkout', 'Clicked PayPal Smart Button', 'Customer Info'))
        }

        fetch("/data/buy/paypalexpressentry",
            {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                if (data.Success) {
                    action.payload.resolve(data.Token);
                } else {
                    action.payload.reject(new Error(JSON.stringify(data)));
                }
            })
            .catch(error => {
                console.error('fetchPayPalExpress', error)
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    fetchPayPalExpressAuthorize: (action, dispatch, getState) => {

        const pathname = (window.location.pathname).toLowerCase();
        if (pathname.startsWith('/shoppingcart') && !navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
            dispatch(sendGoogleAnalyticsEvent('Cart', 'Continued Through PayPal Smart Button Popup', action.payload.data.paymentID))
        }

        let data = {
            paymentId: action.payload.data.paymentID,
            payerId: action.payload.data.payerID
        };
        fetch("/data/buy/paypalexpressreview",
            {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'include'
            }).then(response => response.json())
            .then(json => {
                dispatch(enterCheckout(action.payload.price))
                if (action.payload.isMvcRedirect) {
                    window.location.href = json.RedirectUrl
                } else {
                    action.payload.history.push(json.RedirectUrl);
                }
            })
            .catch(error => {
                console.error('fetchPayPalExpressAuthorize')
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
    updateCarbSubclassForm: (action, dispatch, getState) => {
        let carbSubclassForm = getState().transaction.carb.yearMakeModelData

        const data = {
            year: action.payload.year,
            make: action.payload.make,
            model: action.payload.model,
        };

        return fetch("/data/buy/updatecarbsubclassitems",
            {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveCarbSubclassForm(json));
            })
            .catch(error => {
                dispatch(Actions.disableLoader())
                alert(genericErrorMessage)
            })
    },
}



function UpdatePaymentForPaymentTech(transaction, dispatch, action) {
    if (action.payload !== "Credit Card")
        return false;

    dispatch(Actions.erasePaymentTechIframe())

    const transactionId = transaction.transactionId;

    let data = {
        transactionId: transactionId
    };

    return fetch("/data/buy/getpaymentechiframe",
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include'
        })
        .then(response => response.json())
        .then(json => {
            if (!json.status.success) {
                Actions.handleErrors(json.status, true, dispatch)
            }
            if (json.checkoutTransactionRm) {
                dispatch(Actions.updatePaymentTechIframe(json));
            }
        })
        .catch(error => {
            console.error('selectPaymentOption Error:', error)
            dispatch(Actions.disableLoader())
            alert(genericErrorMessage)
        })
}

export default CheckoutApiMiddlewareAction
